import React, { Component } from 'react'
import { connect } from 'react-redux'
import commonAction from '../../actions/common'
import './index.scss'
import {
  getMe,
  loadAssignUsers,
  pageList,
  assignUser,
  assignChangeApply,
  renewConfirm,
  uploadBase64,
  recoverCenter,
  arList,
  createCase,
  advanceCase,
  caseLogs,
  settleCase,
  collectAr,
  CC_FLOW,
} from '../../api/ContractCollect'

function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}
function money(n) {
  return (Number(n) || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
function fmt(d) {
  return d ? String(d).substr(0, 10) : '—'
}

class ContractCollect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: 'renew',
      renewView: 'all',
      collectView: 'all',
      renewList: [],
      collectList: [],
      center: {},
      assignUserList: [],
      me: null,
      tokenOk: false,
      renewLoading: false,
      collectLoading: false,
      modal: null, // {type:'assign'|'renew'|'createCase'|'caseFlow'|'caseLogs'|'settle'|'collect', ...}
    }
  }

  componentDidMount() {
    if (this.props.path) {
      try {
        this.props.dispatch({ type: commonAction.setPathname, pathname: this.props.path })
      } catch (e) {}
    }
    const me = getMe()
    this.setState({ me, tokenOk: !!me && !!me.userId })
    if (me && me.userId) {
      loadAssignUsers().then(res => {
        if (res.code === 200 && Array.isArray(res.data)) {
          this.setState({ assignUserList: res.data })
        }
      })
      this.loadRenew()
      this.loadCollect()
      this.loadCenter()
    }
  }

  /* ---------- 续签人板块 ---------- */
  loadRenew = () => {
    this.setState({ renewLoading: true })
    const { renewView, me } = this.state
    const p = { pageIndex: 1, pageSize: 100, sortField: 'assign_time', sortOrder: 'desc' }
    if (renewView === 'mine') { p.assignUserId = me.userId; p.onlyUnReceived = true }
    else if (renewView === 'myall') { p.assignUserId = me.userId }
    else if (renewView === 'iassign') { p.assignOperator = me.userId }
    else if (renewView === 'assigned') { p.onlyUnReceived = true; p.hasAssign = 1 }
    else if (renewView === 'done') { p.onlyUnReceived = false; p.hasAssign = 1 }
    pageList(p).then(res => {
      if (res.code !== 200) {
        this.setState({ renewList: [], renewLoading: false })
        return
      }
      this.setState({ renewList: (res.data && res.data.list) || [], renewLoading: false })
    })
  }

  switchRenewView = v => {
    this.setState({ renewView: v }, this.loadRenew)
  }

  openAssign = c => {
    this.setState({
      modal: {
        type: 'assign',
        contractId: c.contractId,
        contractNumber: c.contractNumber || '',
        curName: c.assignUserName || null,
        isChange: !!c.assignUserName,
      },
    })
  }

  doAssign = () => {
    const { modal, assignUserList, me } = this.state
    const sel = document.getElementById('cc-mAssignSel')
    const uid = sel ? sel.value : ''
    if (!uid) { window.alert('请选择签约人'); return }
    const target = (assignUserList || []).find(u => String(u.userId) === String(uid)) || {}
    // 微信端统一提交「签约人变更申请」，由后台合同生成器第①步审核通过后生效
    assignChangeApply({
      contractId: modal.contractId,
      assignUserId: parseInt(uid, 10),
      assignUserName: target.nickname || '',
      applyUserName: me ? (me.nickname || '') : '',
    }).then(res => {
      if (res.code === 200) {
        this.setState({ modal: null })
        window.alert((modal.isChange ? '更换签约人' : '指派签约人') + '申请已提交，等待后台「合同生成器-①系统数据」审核通过后生效')
        this.loadRenew()
      } else {
        window.alert(res.message || '提交失败')
      }
    })
  }

  openRenewConfirm = c => {
    this.setState({
      modal: {
        type: 'renew',
        contractId: c.contractId,
        contractNumber: c.contractNumber || '',
        unit: c.propertyUnitName || '',
        amount: c.contractAmount || 0,
        photos: [],
      },
    })
  }

  // 签回拍照：选图 → 转 base64 → 上传 → 记录 URL
  pickRenewPhoto = e => {
    const files = e.target.files || []
    if (!files.length) return
    const file = files[0]
    const reader = new FileReader()
    reader.onload = () => {
      const raw = String(reader.result || '')
      const base64 = raw.replace(/^data:[^;]+;base64,/, '')
      uploadBase64({ base64 }).then(res => {
        if (res.code === 200 && res.data && res.data.url) {
          const { modal } = this.state
          if (!modal) return
          this.setState({ modal: Object.assign({}, modal, { photos: (modal.photos || []).concat(res.data.url) }) })
        } else {
          window.alert(res.message || '照片上传失败')
        }
      })
    }
    reader.readAsDataURL(file)
    e.target.value = ''
  }

  removeRenewPhoto = idx => {
    const { modal } = this.state
    if (!modal) return
    const photos = (modal.photos || []).filter((p, i) => i !== idx)
    this.setState({ modal: Object.assign({}, modal, { photos }) })
  }

  doRenewConfirm = () => {
    const { modal } = this.state
    const photos = (modal.photos || []).join(',')
    renewConfirm({ contractId: modal.contractId, photos: photos }).then(res => {
      if (res.code === 200) {
        this.setState({ modal: null })
        window.alert('签回成功，账单与维保任务已生成')
        this.loadRenew()
        this.loadCollect()
      } else {
        window.alert(res.message || '签回失败')
      }
    })
  }

  /* ---------- 催收板块 ---------- */
  loadCenter = () => {
    recoverCenter().then(res => {
      if (res.code !== 200) return
      this.setState({ center: res.data || {} })
    })
  }

  loadCollect = () => {
    this.setState({ collectLoading: true })
    const { collectView } = this.state
    arList({ view: collectView === 'all' ? 'all' : collectView }).then(res => {
      if (res.code !== 200) {
        this.setState({ collectList: [], collectLoading: false })
        return
      }
      this.setState({ collectList: res.data || [], collectLoading: false })
    })
  }

  switchCollectView = v => {
    this.setState({ collectView: v }, this.loadCollect)
  }

  openCreateCase = c => {
    this.setState({
      modal: { type: 'createCase', arId: c.id, name: c.customerName || '', left: (Number(c.receivableAmount) || 0) - (Number(c.receivedAmount) || 0) },
    })
  }

  doCreateCase = () => {
    const { modal } = this.state
    createCase({ arPlanId: modal.arId }).then(res => {
      if (res.code === 200) {
        this.setState({ modal: null })
        window.alert('催收已发起')
        this.loadCollect()
        this.loadCenter()
      } else {
        window.alert(res.message || '发起失败')
      }
    })
  }

  openCaseFlow = c => {
    this.setState({
      modal: { type: 'caseFlow', caseId: c.caseId, name: c.customerName || '', stage: c.caseStage || 1 },
    })
  }

  doAdvance = () => {
    const { modal } = this.state
    const toEl = document.getElementById('cc-mToStep')
    const noteEl = document.getElementById('cc-mNote')
    const to = toEl ? toEl.value : ''
    const note = noteEl ? noteEl.value.trim() : ''
    if (!to) { window.alert('请选择目标环节'); return }
    advanceCase({ id: modal.caseId, to: parseInt(to, 10), note }).then(res => {
      if (res.code === 200) {
        this.setState({ modal: null })
        window.alert('环节已推进')
        this.loadCollect()
        this.loadCenter()
      } else {
        window.alert(res.message || '推进失败')
      }
    })
  }

  openCaseLogs = c => {
    const name = c.customerName || ''
    caseLogs({ caseId: c.caseId }).then(res => {
      const logs = (res.code === 200 && res.data) || []
      this.setState({ modal: { type: 'caseLogs', name, logs } })
    })
    this.setState({ modal: { type: 'caseLogs', name, logs: [], loading: true } })
  }

  openSettle = c => {
    const left = (Number(c.receivableAmount) || 0) - (Number(c.receivedAmount) || 0)
    this.setState({
      modal: { type: 'settle', caseId: c.caseId, name: c.customerName || '', left },
    })
  }

  doSettle = () => {
    const { modal } = this.state
    const amtEl = document.getElementById('cc-mSettleAmt')
    const mtdEl = document.getElementById('cc-mSettleMethod')
    const amt = amtEl ? parseFloat(amtEl.value) : NaN
    const mtd = mtdEl ? parseInt(mtdEl.value, 10) : 1
    if (!amt || amt <= 0) { window.alert('请输入有效金额'); return }
    settleCase({ id: modal.caseId, amount: amt, method: mtd }).then(res => {
      if (res.code === 200) {
        this.setState({ modal: null })
        window.alert('已结清核销，应收闭环关闭，信用已上调')
        this.loadCollect()
        this.loadCenter()
      } else {
        window.alert(res.message || '核销失败')
      }
    })
  }

  openCollect = c => {
    const left = (Number(c.receivableAmount) || 0) - (Number(c.receivedAmount) || 0)
    this.setState({
      modal: { type: 'collect', arId: c.id, name: c.customerName || '', left },
    })
  }

  doCollect = () => {
    const { modal } = this.state
    const amtEl = document.getElementById('cc-mAmt')
    const mtdEl = document.getElementById('cc-mMethod')
    const amt = amtEl ? parseFloat(amtEl.value) : NaN
    const mtd = mtdEl ? parseInt(mtdEl.value, 10) : 1
    if (!amt || amt <= 0) { window.alert('请输入有效金额'); return }
    collectAr({ id: modal.arId, amount: amt, method: mtd }).then(res => {
      if (res.code === 200) {
        this.setState({ modal: null })
        window.alert('核销成功')
        this.loadCollect()
        this.loadCenter()
      } else {
        window.alert(res.message || '核销失败')
      }
    })
  }

  closeModal = () => this.setState({ modal: null })

  /* ---------- 渲染 ---------- */
  renderRenewList() {
    const { renewList, renewLoading } = this.state
    if (renewLoading) return <div className="cc-loading">加载中...</div>
    if (!renewList.length) return <div className="cc-empty">暂无续签合同任务</div>
    return renewList.map(c => {
      const done = c.receiveStatus === 1
      const hasAssign = !!c.assignUserName
      const chg = c.assignChangeStatus
      const tag = done
        ? <span className="cc-tag cc-done">已签回</span>
        : (hasAssign ? <span className="cc-tag cc-assign">待签约</span> : null)
      const chgTag = chg === 1
        ? <span className="cc-tag cc-warn" style={{ top: '38px' }}>变更待审核</span>
        : (chg === 3 ? <span className="cc-tag cc-normal" style={{ top: '38px' }}>变更被驳回</span> : null)
      const btns = []
      if (done) {
        btns.push(<span key="d" className="cc-abtn cc-ghost" disabled>已签回 · 流程完成</span>)
      } else {
        btns.push(
          <span key="a" className="cc-abtn cc-primary" onClick={() => this.openAssign(c)}>
            {hasAssign ? '更换签约人' : '指派签约人'}
          </span>
        )
        if (hasAssign) {
          btns.push(
            <span key="r" className="cc-abtn cc-ok" onClick={() => this.openRenewConfirm(c)}>签回确认</span>
          )
        }
      }
      return (
        <div className="cc-item" key={c.contractId}>
          {tag}
          {chgTag}
          <div className="cc-nm">{esc(c.propertyUnitName || '')}</div>
          <div className="cc-sub">
            合同：{esc(c.contractNumber || '—')} ｜ 金额：<span className="cc-amt">{money(c.contractAmount)}</span> ｜ 台量：{c.liftNum || 0}
          </div>
          <div className="cc-sub">
            签约人：{c.assignUserName
              ? `${esc(c.assignUserName)}（${fmt(c.assignTime)}）`
              : '—'}
            {' '}｜ 到期：{fmt(c.endTime)}
          </div>
          <div className="cc-actions">{btns}</div>
        </div>
      )
    })
  }

  renderCollectList() {
    const { collectList, collectLoading } = this.state
    if (collectLoading) return <div className="cc-loading">加载中...</div>
    if (!collectList.length) return <div className="cc-empty">暂无应收数据</div>
    return collectList.map(c => {
      const od = String(c.status) === 'overdue'
      const amt = Number(c.receivableAmount) || 0
      const rec = Number(c.receivedAmount) || 0
      const left = amt - rec
      const st = String(c.status)
      const tag = st === 'settled'
        ? <span className="cc-tag cc-done">已结清</span>
        : (c.caseId
          ? <span className="cc-tag cc-stage">催收中·{esc(c.caseStageName || '')}</span>
          : (od
            ? <span className="cc-tag cc-od">逾期{c.overdueDays ? ' ' + c.overdueDays + '天' : ''}</span>
            : <span className="cc-tag cc-normal">正常</span>))
      const btns = []
      if (st === 'settled') {
        btns.push(<span key="s" className="cc-abtn cc-ghost" disabled>已结清</span>)
      } else if (c.caseId) {
        btns.push(
          <span key="f" className="cc-abtn cc-warn" onClick={() => this.openCaseFlow(c)}>推进环节</span>,
          <span key="l" className="cc-abtn cc-primary" onClick={() => this.openCaseLogs(c)}>催收留痕</span>,
          <span key="se" className="cc-abtn cc-ok" onClick={() => this.openSettle(c)}>结清核销</span>
        )
      } else {
        btns.push(
          <span key="c" className="cc-abtn cc-danger" onClick={() => this.openCreateCase(c)}>发起催收</span>,
          <span key="co" className="cc-abtn cc-ok" onClick={() => this.openCollect(c)}>收款核销</span>
        )
      }
      return (
        <div className="cc-item" key={c.id}>
          {tag}
          <div className="cc-nm">{esc(c.customerName)}</div>
          <div className="cc-sub">
            合同：{esc(c.contractNumber || '—')} ｜ 应收：<span className="cc-amt">{money(amt)}</span> ｜ 已收：<span className="cc-rec">{money(rec)}</span> ｜ 欠款：{money(left)}
          </div>
          <div className="cc-sub">应收日：{fmt(c.receivableTime)} ｜ 到期：{fmt(c.dueDate)}</div>
          <div className="cc-actions">{btns}</div>
        </div>
      )
    })
  }

  renderAging() {
    const { center } = this.state
    const aging = center.aging || []
    const total = center.odTotal || 0
    if (!aging.length) return <div style={{ fontSize: 12, color: '#909399', textAlign: 'center', width: '100%' }}>无账龄数据</div>
    const labels = { a1: '30天内', a2: '31-60', a3: '61-90', a4: '91-180', a5: '180天+' }
    return aging.map(a => {
      const pct = total ? Math.round((Number(a.sum) / total) * 100) : 0
      return (
        <div className="cc-abar" key={a.key}>
          <div className="cc-val">{money(a.sum)}</div>
          <div className="cc-bar" style={{ opacity: 0.25 + pct * 0.75 / 100 }} />
          <div>{labels[a.key] || a.key}</div>
        </div>
      )
    })
  }

  renderModal() {
    const { modal, assignUserList } = this.state
    if (!modal) return null
    let title = '', sub = '', body = null
    switch (modal.type) {
      case 'assign': {
        title = '指派签约人'
        sub = `合同 ${modal.contractNumber}${modal.curName ? ' ｜ 当前：' + modal.curName : ''}`
        body = (
          <div>
            <select className="cc-sel" id="cc-mAssignSel" defaultValue="">
              <option value="">请选择签约人…</option>
              {assignUserList.map(u => (
                <option key={u.userId} value={u.userId}>{esc(u.nickname || '')}（{esc(u.phone || '')}）</option>
              ))}
            </select>
            <div className="cc-btnrow">
              <button className="cc-btn" onClick={this.doAssign}>确认{modal.isChange ? '更换' : '指派'}</button>
              <button className="cc-btn cc-gray" onClick={this.closeModal}>取消</button>
            </div>
          </div>
        )
        break
      }
      case 'renew': {
        title = '签回确认'
        sub = `${modal.unit} ｜ 合同 ${modal.contractNumber}`
        const photos = modal.photos || []
        body = (
          <div>
            <div className="cc-hint" style={{ margin: '0 0 10px' }}>
              确认该合同已由签约人签回？签回后将生成<b style={{ color: '#1667a9' }}>收款账单</b>与<b style={{ color: '#1667a9' }}>维保任务</b>；后台「合同生成器-①系统数据」还可审核签回照片、生成维保计划、确定账期。
            </div>
            <div className="cc-photo-label">签回回执照片（选填，建议拍合同签字页/盖章页）</div>
            <div className="cc-photo-row">
              {photos.map((p, pi) => (
                <span className="cc-photo-item" key={pi}>
                  <img src={p} alt="" />
                  <i onClick={() => this.removeRenewPhoto(pi)}>×</i>
                </span>
              ))}
              {photos.length < 3 && (
                <label className="cc-photo-add">
                  <input type="file" accept="image/*" capture="environment" style={{ display: 'none' }} onChange={this.pickRenewPhoto} />
                  <span>📷 拍照</span>
                </label>
              )}
            </div>
            <div className="cc-btnrow">
              <button className="cc-btn" onClick={this.doRenewConfirm}>确认签回 · 生成账单</button>
              <button className="cc-btn cc-gray" onClick={this.closeModal}>取消</button>
            </div>
          </div>
        )
        break
      }
      case 'createCase': {
        title = '发起催收'
        sub = `${modal.name} ｜ 欠款 ${money(modal.left)} 元`
        body = (
          <div>
            <div className="cc-hint" style={{ margin: '0 0 12px' }}>
              将对该笔应收建立催款单，进入8步催收流程：到期提醒→电话→函件→上门→停保→法务→折让→结清。
            </div>
            <div className="cc-btnrow">
              <button className="cc-btn cc-danger" onClick={this.doCreateCase}>确认发起</button>
              <button className="cc-btn cc-gray" onClick={this.closeModal}>取消</button>
            </div>
          </div>
        )
        break
      }
      case 'caseFlow': {
        title = '推进催收环节'
        sub = `${modal.name} ｜ 当前：${CC_FLOW[modal.stage - 1] ? CC_FLOW[modal.stage - 1][0] : ''}`
        const flow = (
          <div className="cc-flow">
            {CC_FLOW.map((f, i) => {
              const cls = i + 1 < modal.stage ? 'cc-done' : (i + 1 === modal.stage ? 'cc-cur' : '')
              return <div className={'cc-fnode ' + cls} key={i}>{i + 1}.{f[0]}</div>
            })}
          </div>
        )
        const opts = []
        for (let i = modal.stage + 1; i <= 8; i++) {
          opts.push(<option key={i} value={i}>{CC_FLOW[i - 1][0]}（{CC_FLOW[i - 1][1]}/{CC_FLOW[i - 1][2]}）</option>)
        }
        body = (
          <div>
            {flow}
            <div style={{ height: 10 }} />
            <select className="cc-sel" id="cc-mToStep" defaultValue="">
              {opts.length ? opts : <option value="">当前已是最后环节</option>}
            </select>
            <textarea className="cc-inp" id="cc-mNote" placeholder="本次环节记录（如：已电话联系客户，承诺本周付款）" />
            <div className="cc-btnrow">
              <button className="cc-btn" onClick={this.doAdvance}>推进</button>
              <button className="cc-btn cc-gray" onClick={this.closeModal}>取消</button>
            </div>
          </div>
        )
        break
      }
      case 'caseLogs': {
        title = '催收留痕'
        sub = modal.name
        body = modal.loading ? <div className="cc-loading">加载中...</div> : (modal.logs && modal.logs.length
          ? modal.logs.map((l, i) => (
              <div className="cc-logrow" key={i}>
                <b>{esc(l.who || '-')}</b> {esc(l.way || '')} ｜ {fmt(l.whenAt)}
                <span className="cc-st">{esc(l.result || '')}</span>
                <br />{esc(l.content || '')}
                {l.next ? <span><br /><span style={{ color: '#b26a1b' }}>下次：{esc(l.next)}</span></span> : null}
              </div>
            ))
          : <div className="cc-empty">暂无催收记录</div>)
        break
      }
      case 'settle': {
        title = '结清核销'
        sub = `${modal.name} ｜ 欠款 ${money(modal.left)} 元`
        body = (
          <div>
            <input className="cc-inp" id="cc-mSettleAmt" type="number" placeholder="本次核销金额（元）" defaultValue={modal.left} />
            <select className="cc-sel" id="cc-mSettleMethod" defaultValue="1">
              <option value="1">现金</option><option value="2">银行转账</option><option value="3">微信</option>
              <option value="4">支付宝</option><option value="5">支票</option><option value="6">其他</option>
            </select>
            <div className="cc-btnrow">
              <button className="cc-btn cc-danger" onClick={this.doSettle}>确认结清</button>
              <button className="cc-btn cc-gray" onClick={this.closeModal}>取消</button>
            </div>
          </div>
        )
        break
      }
      case 'collect': {
        title = '收款核销'
        sub = `${modal.name} ｜ 欠款 ${money(modal.left)} 元`
        body = (
          <div>
            <input className="cc-inp" id="cc-mAmt" type="number" placeholder="本次核销金额（元）" defaultValue={modal.left} />
            <select className="cc-sel" id="cc-mMethod" defaultValue="1">
              <option value="1">现金</option><option value="2">银行转账</option><option value="3">微信</option>
              <option value="4">支付宝</option><option value="5">支票</option><option value="6">其他</option>
            </select>
            <div className="cc-btnrow">
              <button className="cc-btn cc-ok" onClick={this.doCollect}>确认核销</button>
              <button className="cc-btn cc-gray" onClick={this.closeModal}>取消</button>
            </div>
          </div>
        )
        break
      }
      default:
        return null
    }
    return (
      <div className="cc-mask show" onClick={e => { if (e.target === e.currentTarget) this.closeModal() }}>
        <div className="cc-modal">
          <h3>{title}</h3>
          <div className="cc-msub">{sub}</div>
          {body}
        </div>
      </div>
    )
  }

  render() {
    const { tab, renewView, collectView, center, me, tokenOk } = this.state
    if (!tokenOk) {
      return (
        <div style={{ minHeight: '100vh', background: '#f5f6f8' }}>
          <div className="cc-tabs">
            <div className="cc-tab on">续签人<span className="cc-cnt">0</span></div>
            <div className="cc-tab">催收<span className="cc-cnt">0</span></div>
          </div>
          <div className="cc-empty" style={{ paddingTop: 80 }}>登录状态失效，请返回首页重新登录后再次进入</div>
          <div className="cc-footer">温州开源电梯 · 合同催收中心（续签 → 签回 → 回款闭环）</div>
        </div>
      )
    }
    return (
      <div style={{ minHeight: '100vh', background: '#f5f6f8' }}>
        <div className="cc-tabs">
          <div className={'cc-tab' + (tab === 'renew' ? ' on' : '')} onClick={() => this.setState({ tab: 'renew' })}>
            续签人<span className="cc-cnt" id="cc-cntRenew">{this.state.renewList.length}</span>
          </div>
          <div className={'cc-tab' + (tab === 'collect' ? ' on' : '')} onClick={() => this.setState({ tab: 'collect' })}>
            催收<span className="cc-cnt" id="cc-cntCollect">{this.state.collectList.length}</span>
          </div>
        </div>
        <div className="cc-who">{me ? `${me.nickname || ''} · 续签 / 催收闭环` : ''}</div>

        {tab === 'renew' ? (
          <div id="cc-panel-renew">
            <div className="cc-filter" id="cc-renewFilter">
              {[['all', '全部'], ['mine', '我的待签'], ['myall', '我的任务'], ['iassign', '我指派的'], ['assigned', '待签约'], ['done', '已签回']].map(([v, t]) => (
                <span key={v} className={'cc-fbtn' + (renewView === v ? ' on' : '')} onClick={() => this.switchRenewView(v)}>{t}</span>
              ))}
            </div>
            <div id="cc-renewList">{this.renderRenewList()}</div>
          </div>
        ) : (
          <div id="cc-panel-collect">
            <div className="cc-card">
              <div className="cc-ov-row">
                <div className="cc-ov"><div className="cc-num" id="cc-odTotal">{money(center.odTotal)}</div><div className="cc-lbl">逾期总额(元)</div></div>
                <div className="cc-ov"><div className="cc-num cc-blue" id="cc-odCount">{(center.odCount || 0) + ' 笔'}</div><div className="cc-lbl">逾期笔数</div></div>
                <div className="cc-ov"><div className="cc-num cc-gray" id="cc-maxOd">{(center.maxOd || 0) + ' 天'}</div><div className="cc-lbl">最长逾期(天)</div></div>
              </div>
              <div className="cc-aging" id="cc-agingRow">{this.renderAging()}</div>
            </div>
            <div className="cc-filter" id="cc-collectFilter">
              {[['all', '全部应收'], ['overdue', '逾期'], ['running', '催收中'], ['settled', '已结清']].map(([v, t]) => (
                <span key={v} className={'cc-fbtn' + (collectView === v ? ' on' : '')} onClick={() => this.switchCollectView(v)}>{t}</span>
              ))}
            </div>
            <div id="cc-collectList">{this.renderCollectList()}</div>
          </div>
        )}

        <div className="cc-footer">温州开源电梯 · 合同催收中心（续签 → 签回 → 回款闭环）</div>
        {this.renderModal()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    pathname: state.commonR && state.commonR.pathname,
  }
}

export default connect(mapStateToProps)(ContractCollect)
